"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserMenuInfo = exports._getCreateEventMenuItems = exports.getAttendeeUserMenuItems = exports.getStaffUserMenuItems = exports.getOrganizeMenu = exports.getHelpMenu = exports.getNonUserQuickLinks = exports.getSearchInfo = exports.getCreateEventCTA = exports.getBrowseEventsQuickLinks = exports.getLogoInfoUrl = exports.getLogoInfo = exports.isHomepage = void 0;

var _react = _interopRequireDefault(require("react"));

var _gettext = _interopRequireDefault(require("js-utils/gettext"));

var _lazyGettext = _interopRequireDefault(require("js-utils/lazy-gettext"));

var _momentTimezone = _interopRequireDefault(require("js-utils/moment-timezone"));

var _constants = require("eventbrite_design_system/navListItem/constants");

var _Icon = _interopRequireDefault(require("eventbrite_design_system/icon/Icon"));

var _Link = _interopRequireDefault(require("eventbrite_design_system/link/Link"));

var _PhoneChunky = _interopRequireDefault(require("eventbrite_design_system/iconography/icons/PhoneChunky"));

var _siteAnalytics = require("@eb/site-analytics");

var _isNumber = _interopRequireDefault(require("lodash/isNumber"));

var _isString = _interopRequireDefault(require("lodash/isString"));

var _user = require("./user");

var _constants2 = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isHomepage = function isHomepage(requestPath) {
  return requestPath === '/';
};
/**
 * Generates data needed to pass as `logoInfo` prop to EDS Global Header
 * @param {string} url URL to navigate to when logo is clicked
 * @param {string} requestPath Current request path (for analytics)
 * @param {object} [logoOptions={}] Additional options matching the EDS Global Header `logoInfo` prop
 * @returns {object}
 */


exports.isHomepage = isHomepage;

var getLogoInfo = function getLogoInfo(url, requestPath) {
  var logoOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return _objectSpread({
    url: url,
    onClick: (0, _siteAnalytics.getAnalyticsClickHandler)({
      requestPath: requestPath,
      action: _constants2.ACTION_LOGO_HOME,
      category: _constants2.CATEGORY_HEADER
    })
  }, logoOptions);
};

exports.getLogoInfo = getLogoInfo;
var knownOrganizerManageUrlPathsRegexp = /^\/(affiliates|facebook-publish|links|manage\/events|myevent|organizations|questions)/;
/**
 * Generates a link for the logo based on the current context.
 *
 * Generally, this helps Music customers get back to their events listing
 * rather than the consumer homepage.
 *
 * @param {string} user         The currently logged-in user
 * @param {string} fallbackUrl  The original URL to fall back on
 * @param {string} requestPath  The current path the user is navigating from
 */

var getLogoInfoUrl = function getLogoInfoUrl(user, fallbackUrl, requestPath) {
  if (user && user.usesNewPermissions && knownOrganizerManageUrlPathsRegexp.test(requestPath)) {
    return '/organizations/events';
  }

  return fallbackUrl;
};
/**
 * Retrieves list of browse events-related quick links to pass to `quickLinks` prop of EDS Global Header
 * @param {string} serverUrl Base site URL (e.g. "http://www.eventbrite.com")
 * @param {string} ebDomain Current site domain (for Janus checkpoint)
 * @param {string} requestPath Current request path (for analytics)
 * @returns {object[]}
 */


exports.getLogoInfoUrl = getLogoInfoUrl;

var getBrowseEventsQuickLinks = function getBrowseEventsQuickLinks(serverUrl, ebDomain, requestPath, showReportBugLinkInHeader) {
  // for non-search pages (including "/events/" city browse pages),
  // show a link to lead the user to the search page
  if ((0, _isString.default)(requestPath) && !requestPath.match('^/d/(?!.*/events/)')) {
    return [{
      url: "".concat(serverUrl, "/d/local/all-events/"),
      content: (0, _gettext.default)('Browse Events'),
      onClick: (0, _siteAnalytics.getAnalyticsClickHandler)({
        requestPath: requestPath,
        action: _constants2.ACTION_DISCOVER,
        category: _constants2.CATEGORY_HEADER
      }, {
        checkpointName: 'discover_header_link_clicked',
        domain: ebDomain
      })
    }];
  } // on the search page, show britelings a link to report a bug


  if (showReportBugLinkInHeader) {
    return [{
      url: 'https://docs.google.com/forms/d/1Ry6fD4p-E6Eg4Uzkaf8GRybPAbWiVwIMdUpUxfrShUs/edit',
      content: (0, _gettext.default)('Report a Bug (Internal)')
    }];
  }

  return [];
};
/**
 * Gets the info for displaying create event CTA to be passed to `callToActionInfo` prop of EDS Global Header
 * @param {string} serverUrl Base site URL (e.g. "http://www.eventbrite.com")
 * @param {string} ebDomain Current site domain (for Janus checkpoint)
 * @param {string} requestPath Current request path (for analytics)
 * @param {boolean} isAuthenticated Whether or not the user is authenticated
 * @param {boolean} canCreateEvents Whether or not the user can create events
 * @param {React.ReactNode} [content='Create Event'] The content of the CTA
 * @param {object} [dimensions={}] Additional GA dimensions for when the CTA is clicked
 * @returns {object}
 */


exports.getBrowseEventsQuickLinks = getBrowseEventsQuickLinks;

var getCreateEventCTA = function getCreateEventCTA(serverUrl, ebDomain, requestPath, isAuthenticated, canCreateEvents) {
  var content = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : (0, _lazyGettext.default)('Create Event');
  var dimensions = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : {};
  var callToAction;

  if (canCreateEvents || isHomepage(requestPath)) {
    var dataAttributes = {
      'data-automation': 'global-nav-create',
      onClick: (0, _siteAnalytics.getAnalyticsClickHandler)({
        requestPath: requestPath,
        action: _constants2.ACTION_CREATE_ATTEMPT,
        category: _constants2.CATEGORY_HEADER,
        dimensions: dimensions
      }, {
        checkpointName: 'hiw_global_header_cta_clicked',
        pageWillChange: isAuthenticated,
        domain: ebDomain
      })
    };
    callToAction = _objectSpread({
      url: "".concat(serverUrl, "/create/"),
      content: content
    }, dataAttributes);
  }

  return callToAction;
};
/**
 * @typedef SearchSuggestion
 * @property {string} value
 * @property {string} content
 */

/**
 * Gets the search information passed to the `searchInfo` prop of EDS Global Header
 * @param {string} serverUrl Base site URL (e.g. "http://www.eventbrite.com")
 * @param {string} query Current search query
 * @param {SearchSuggestion[]} suggestions Search suggestions for auto-complete
 * @param {boolean} hideSearchBar Whether or not to hide the search bar
 * @returns {object}
 */


exports.getCreateEventCTA = getCreateEventCTA;

var getSearchInfo = function getSearchInfo(serverUrl, query, suggestions, hideSearchBar) {
  var searchInfo;

  if (!hideSearchBar) {
    searchInfo = {
      formAction: "".concat(serverUrl, "/d/"),
      label: (0, _gettext.default)('Search for events'),
      query: query,
      suggestions: suggestions
    };
  }

  return searchInfo;
};
/**
 * Gets list of links usually passed as `nonUserQuickLinks` prop to EDS Global Header
 * @param {string} requestPath Current request path (for analytics)
 * @param {boolean} isAuthenticated Whether or not the user is authenticated
 * @param {string} loginUrl URL to the sign-in page
 * @returns object[]
 */


exports.getSearchInfo = getSearchInfo;

var getNonUserQuickLinks = function getNonUserQuickLinks(requestPath, isAuthenticated, loginUrl) {
  if (isAuthenticated) {
    return null;
  }

  return [{
    url: loginUrl,
    content: (0, _gettext.default)('Sign In'),
    onClick: (0, _siteAnalytics.getAnalyticsClickHandler)({
      requestPath: requestPath,
      action: _constants2.ACTION_LOGIN_ATTEMPT,
      category: _constants2.CATEGORY_HEADER
    })
  }];
};

exports.getNonUserQuickLinks = getNonUserQuickLinks;

var _getTimezoneAbbreviation = function _getTimezoneAbbreviation() {
  var timeZone = _momentTimezone.default.tz.guess();

  var time = new Date();
  var timeZoneOffset = time.getTimezoneOffset();
  return _momentTimezone.default.tz.zone(timeZone).abbr(timeZoneOffset);
};

var _getPhoneSupportDisplayTime = function _getPhoneSupportDisplayTime(time, format) {
  var userTimezone = _momentTimezone.default.tz.guess();

  var defaultTimeWithTimezone = _momentTimezone.default.tz(time, format, _constants2.PHONE_SUPPORT_DEFAULT_TIMEZONE);

  return defaultTimeWithTimezone.clone().tz(userTimezone).format(format);
};

var _getAvailableHoursDisplay = function _getAvailableHoursDisplay() {
  var startTime = _getPhoneSupportDisplayTime(_constants2.PHONE_SUPPORT_START_TIME, _constants2.PHONE_SUPPORT_START_TIME_FORMAT);

  var endTime = _getPhoneSupportDisplayTime(_constants2.PHONE_SUPPORT_END_TIME, _constants2.PHONE_SUPPORT_END_TIME_FORMAT);

  var timezone = _getTimezoneAbbreviation();

  return "".concat(startTime, " - ").concat(endTime, " ").concat(timezone);
};

var _isWeekend = function _isWeekend(dateNow) {
  var day = dateNow.day();
  return day === 6 || day === 0;
};

var _isPhoneSupportOnline = function _isPhoneSupportOnline() {
  // users local time transposed to the default timezone
  // ex: 6am PST => 8am CST
  var localTimeTransposed = _momentTimezone.default.tz((0, _momentTimezone.default)(), _constants2.PHONE_SUPPORT_DEFAULT_TIMEZONE);

  var isOnline = false;

  if (_isWeekend(localTimeTransposed)) {
    return isOnline;
  }

  var beforeTime = (0, _momentTimezone.default)(_constants2.PHONE_SUPPORT_START_TIME, _constants2.PHONE_SUPPORT_START_TIME_FORMAT);
  var afterTime = (0, _momentTimezone.default)(_constants2.PHONE_SUPPORT_END_TIME, _constants2.PHONE_SUPPORT_END_TIME_FORMAT);

  if (localTimeTransposed.isBetween(beforeTime, afterTime)) {
    isOnline = true;
  }

  return isOnline;
};

var _getPhoneSupportLink = function _getPhoneSupportLink(requestPath, isSuperCreator) {
  if (!isSuperCreator) {
    return [];
  }

  var phoneSupportLink = /*#__PURE__*/_react.default.createElement("p", {
    className: "eds-text-color--ui-500"
  }, "".concat(_constants2.PHONE_SUPPORT_NUMBER, " (offline)"));

  if (_isPhoneSupportOnline()) {
    phoneSupportLink = /*#__PURE__*/_react.default.createElement(_Link.default, {
      to: "tel:".concat(_constants2.PHONE_SUPPORT_NUMBER),
      style: "inverse"
    }, _constants2.PHONE_SUPPORT_NUMBER);
  }

  return [{
    type: _constants.DIVIDER
  }, {
    type: _constants.ANCHOR_LINK,
    content: /*#__PURE__*/_react.default.createElement("div", {
      className: "eds-align--space-around"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "eds-l-mar-right-4"
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      type: /*#__PURE__*/_react.default.createElement(_PhoneChunky.default, null)
    })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
      className: "eds-l-mar-bot-1"
    }, phoneSupportLink), /*#__PURE__*/_react.default.createElement("p", null, "Monday - Friday"), /*#__PURE__*/_react.default.createElement("p", null, _getAvailableHoursDisplay()))),
    target: '_blank',
    rel: 'noopener noreferrer',
    onClick: (0, _siteAnalytics.getAnalyticsClickHandler)({
      requestPath: requestPath,
      action: _constants2.ACTION_PHONE_SUPPORT_CLICK,
      category: _constants2.CATEGORY_HEADER,
      label: _constants2.LABEL_HELP_CENTER
    })
  }];
};
/**
 * @typedef {object} UrlInfo
 * @property {string} url Help URL
 * @property {string} label Display label
 * @property {string} gaLabel Google Analytics label
 */

/**
 * Retrieves the help menu info typically passed to the `additionalMenus` prop of the EDS Global Header
 * @param {object} helpUrls
 * @param {string} helpUrls.home
 * @param {UrlInfo[]} helpUrls.suggested
 * @param {string} requestPath Current request path (for analytics)
 * @returns object
 */


var getHelpMenu = function getHelpMenu(_ref, requestPath) {
  var home = _ref.home,
      suggested = _ref.suggested;
  var isSuperCreator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var suggestedHelpMenuItems = suggested.map(function (_ref2) {
    var url = _ref2.url,
        label = _ref2.label,
        gaLabel = _ref2.gaLabel;
    return {
      type: _constants.ANCHOR_LINK,
      path: url,
      content: label,
      onClick: (0, _siteAnalytics.getAnalyticsClickHandler)({
        requestPath: requestPath,
        action: _constants2.ACTION_HELP_ARTICLE,
        category: _constants2.CATEGORY_HEADER,
        label: gaLabel
      })
    };
  });
  var phoneSupportLink = isSuperCreator ? _getPhoneSupportLink(requestPath, isSuperCreator) : [];

  var additionalHelpMenuItems = _toConsumableArray(phoneSupportLink);

  var navItems = [].concat(_toConsumableArray(suggestedHelpMenuItems), [{
    type: _constants.DIVIDER
  }, {
    type: _constants.ANCHOR_LINK,
    path: home,
    content: (0, _gettext.default)('Help Center'),
    target: '_blank',
    rel: 'noopener noreferrer',
    onClick: (0, _siteAnalytics.getAnalyticsClickHandler)({
      requestPath: requestPath,
      action: _constants2.ACTION_HELP_ARTICLE,
      category: _constants2.CATEGORY_HEADER,
      label: _constants2.LABEL_HELP_CENTER
    })
  }], _toConsumableArray(additionalHelpMenuItems));
  return {
    label: (0, _gettext.default)('Help'),
    fallbackUrl: home,
    navItems: navItems
  };
};
/**
 * Gets info to generate Organizer menu item usually passed `additionalMenus` prop of EDS Global Header
 * @param {object} organizeUrls
 * @param {UrlInfo} organizeUrls.home
 * @param {UrlInfo[]} organizeUrls.suggested
 * @param {string} requestPath Current request path (for analytics)
 * @returns {object}
 */


exports.getHelpMenu = getHelpMenu;

var getOrganizeMenu = function getOrganizeMenu(_ref3, requestPath) {
  var homeUrl = _ref3.home.url,
      suggested = _ref3.suggested;
  var suggestedOrganizeMenuItems = suggested.map(function (_ref4) {
    var url = _ref4.url,
        label = _ref4.label,
        gaLabel = _ref4.gaLabel;
    return {
      type: _constants.ANCHOR_LINK,
      path: url,
      content: label,
      onClick: (0, _siteAnalytics.getAnalyticsClickHandler)({
        requestPath: requestPath,
        action: '',
        category: _constants2.CATEGORY_HEADER,
        label: gaLabel
      })
    };
  });

  var navItems = _toConsumableArray(suggestedOrganizeMenuItems);

  return {
    label: (0, _gettext.default)('Organize'),
    fallbackUrl: homeUrl,
    navItems: navItems
  };
};
/**
 * Retrieves the list of staff-related user menu items given the specified configurations
 * @param {object} options
 * @param {object} options.userMenuItemsLookup Lookup of all user menu items
 * @param {boolean} options.isStaff Whether or not the account is a staff account
 * @param {boolean} options.hasTikibar Whether or not the account has access to Tikibar
 * @returns {object[]}
 */


exports.getOrganizeMenu = getOrganizeMenu;

var getStaffUserMenuItems = function getStaffUserMenuItems(_ref5) {
  var userMenuItemsLookup = _ref5.userMenuItemsLookup,
      isStaff = _ref5.isStaff,
      hasTikibar = _ref5.hasTikibar;

  if (!isStaff) {
    return [];
  }

  var admin = userMenuItemsLookup.admin,
      tikibar = userMenuItemsLookup.tikibar,
      featureFlags = userMenuItemsLookup.featureFlags,
      experiments = userMenuItemsLookup.experiments;
  var menuItems = [admin];

  if (hasTikibar) {
    menuItems.push(tikibar);
  }

  menuItems.push(featureFlags, experiments, {
    type: _constants.DIVIDER
  });
  return menuItems;
};
/**
 * Retrieves the list of attendee-related user menu items given the specified configurations
 * @param {object} options
 * @param {object} options.userMenuItemsLookup Lookup of all user menu items
 * @param {number} [options.numFollowing] How many accounts the user is following
 * @param {boolean} options.canUseCollections Whether or not the user has access to collections
 * @param {boolean} options.canUseCredits Whether or not the user has access to credits
 * @param {boolean} options.showBrowseEvents Whether or not to show the "Browse events" menu item
 * @returns {object[]}
 */


exports.getStaffUserMenuItems = getStaffUserMenuItems;

var getAttendeeUserMenuItems = function getAttendeeUserMenuItems(_ref6) {
  var userMenuItemsLookup = _ref6.userMenuItemsLookup,
      numFollowing = _ref6.numFollowing,
      canUseCollections = _ref6.canUseCollections,
      canUseCredits = _ref6.canUseCredits,
      showBrowseEvents = _ref6.showBrowseEvents;
  var browseEvents = userMenuItemsLookup.browseEvents,
      tickets = userMenuItemsLookup.tickets,
      credits = userMenuItemsLookup.credits,
      saved = userMenuItemsLookup.saved,
      following = userMenuItemsLookup.following,
      collections = userMenuItemsLookup.collections,
      interests = userMenuItemsLookup.interests;
  var attendeeItems = [];

  if (showBrowseEvents) {
    attendeeItems.push(browseEvents, {
      type: _constants.DIVIDER
    });
  }

  attendeeItems.push(tickets);

  if (canUseCredits) {
    attendeeItems.push(credits);
  }

  attendeeItems.push(saved);
  attendeeItems.push(following);

  if (canUseCollections) {
    attendeeItems.push(collections);
  }

  attendeeItems.push(interests);
  return attendeeItems;
};

exports.getAttendeeUserMenuItems = getAttendeeUserMenuItems;

var _getOrganizerMenuItems = function _getOrganizerMenuItems(_ref7) {
  var userMenuItemsLookup = _ref7.userMenuItemsLookup,
      canInvite = _ref7.canInvite,
      hasEvents = _ref7.hasEvents,
      hasOrganizers = _ref7.hasOrganizers,
      isAttendee = _ref7.isAttendee,
      canUseSponsorships = _ref7.canUseSponsorships,
      canUseStudio = _ref7.canUseStudio;

  if (isAttendee) {
    return [];
  }

  var manageEvents = userMenuItemsLookup.manageEvents,
      organizerProfile = userMenuItemsLookup.organizerProfile,
      contacts = userMenuItemsLookup.contacts,
      studio = userMenuItemsLookup.studio,
      sponsorships = userMenuItemsLookup.sponsorships;
  var menuItems = [{
    type: _constants.DIVIDER
  }, manageEvents];

  if (hasOrganizers) {
    menuItems.push(organizerProfile);
  }

  if (hasEvents && canInvite) {
    menuItems.push(contacts);
  }

  if (canUseStudio) {
    menuItems.push(studio);
  }

  if (canUseSponsorships) {
    menuItems.push(sponsorships);
  }

  return menuItems;
};

var _getCreateEventMenuItems = function _getCreateEventMenuItems(_ref8) {
  var userMenuItemsLookup = _ref8.userMenuItemsLookup,
      canCreateEvents = _ref8.canCreateEvents;

  if (!canCreateEvents) {
    return [];
  }

  return [userMenuItemsLookup.create];
};

exports._getCreateEventMenuItems = _getCreateEventMenuItems;

var _getUserContentMenuItems = function _getUserContentMenuItems(userMenuItemsLookup) {
  return [userMenuItemsLookup.accountSettingsWithIcon, {
    type: _constants.DIVIDER
  }];
};

var _getUserMenuItems = function _getUserMenuItems(_ref9) {
  var adminServerUrl = _ref9.adminServerUrl,
      canCreateEvents = _ref9.canCreateEvents,
      canInvite = _ref9.canInvite,
      canUseSponsorships = _ref9.canUseSponsorships,
      canUseStudio = _ref9.canUseStudio,
      canUseCollections = _ref9.canUseCollections,
      canUseCredits = _ref9.canUseCredits,
      hasEvents = _ref9.hasEvents,
      hasOrganizers = _ref9.hasOrganizers,
      hasTikibar = _ref9.hasTikibar,
      isAttendee = _ref9.isAttendee,
      isStaff = _ref9.isStaff,
      logoutUrl = _ref9.logoutUrl,
      numOrders = _ref9.numOrders,
      numSavedEvents = _ref9.numSavedEvents,
      numFollowing = _ref9.numFollowing,
      publicId = _ref9.publicId,
      requestPath = _ref9.requestPath,
      serverUrl = _ref9.serverUrl,
      accountSettingsPath = _ref9.accountSettingsPath,
      showBrowseEvents = _ref9.showBrowseEvents,
      email = _ref9.email,
      fullName = _ref9.fullName,
      userImageUrl = _ref9.userImageUrl,
      isManageOverviewActive = _ref9.isManageOverviewActive;
  var userMenuItemsLookup = (0, _user.getUserMenuItemsLookup)({
    adminServerUrl: adminServerUrl,
    logoutUrl: logoutUrl,
    numOrders: numOrders,
    numSavedEvents: numSavedEvents,
    numFollowing: numFollowing,
    publicId: publicId,
    requestPath: requestPath,
    serverUrl: serverUrl,
    accountSettingsPath: accountSettingsPath,
    email: email,
    fullName: fullName,
    userImageUrl: userImageUrl,
    isManageOverviewActive: isManageOverviewActive
  });

  var userMenuItems = _getUserContentMenuItems(userMenuItemsLookup);

  var staffUserMenuItems = getStaffUserMenuItems({
    userMenuItemsLookup: userMenuItemsLookup,
    hasTikibar: hasTikibar,
    isStaff: isStaff
  });
  var attendeeMenuItems = getAttendeeUserMenuItems({
    userMenuItemsLookup: userMenuItemsLookup,
    numFollowing: numFollowing,
    canUseCollections: canUseCollections,
    canUseCredits: canUseCredits,
    showBrowseEvents: showBrowseEvents
  });

  var organizerMenuItems = _getOrganizerMenuItems({
    userMenuItemsLookup: userMenuItemsLookup,
    canInvite: canInvite,
    hasEvents: hasEvents,
    hasOrganizers: hasOrganizers,
    isAttendee: isAttendee,
    canUseSponsorships: canUseSponsorships,
    canUseStudio: canUseStudio
  });

  var createEventMenuItems = _getCreateEventMenuItems({
    userMenuItemsLookup: userMenuItemsLookup,
    canCreateEvents: canCreateEvents
  });

  return [].concat(_toConsumableArray(userMenuItems), _toConsumableArray(staffUserMenuItems), _toConsumableArray(attendeeMenuItems), _toConsumableArray(organizerMenuItems), [{
    type: _constants.DIVIDER
  }, userMenuItemsLookup.accountSettings], _toConsumableArray(createEventMenuItems), [userMenuItemsLookup.logout]);
};
/**
 * Get info for the user menu typically passed to the `userMenuInfo` prop of EDS Global Header
 * @param {object} options
 * @param {string} options.serverUrl Base site URL (e.g. "http://www.eventbrite.com")
 * @param {string} options.adminServerUrl Base Admin site URL (e.gettext. "http://admin.eventbrite.com")
 * @param {string} options.logoutUrl URL to logout page
 * @param {string} options.requestPath Current request path (for analytics)
 * @param {object} options.user User object
 * @param {boolean} options.showBrowseEvents Whether or not to include Browse Events menu item
 * @param {boolean} options.isManageOverviewActive Whether or not the new Manage Overview page is active
 * @param {string} [options.iconColor] Color of the user icon
 */


var getUserMenuInfo = function getUserMenuInfo(_ref10) {
  var serverUrl = _ref10.serverUrl,
      adminServerUrl = _ref10.adminServerUrl,
      logoutUrl = _ref10.logoutUrl,
      requestPath = _ref10.requestPath,
      _ref10$user = _ref10.user,
      canCreateEvents = _ref10$user.canCreateEvents,
      canInvite = _ref10$user.canInvite,
      canUseSponsorships = _ref10$user.canUseSponsorships,
      canUseStudio = _ref10$user.canUseStudio,
      canUseCollections = _ref10$user.canUseCollections,
      firstName = _ref10$user.firstName,
      hasEvents = _ref10$user.hasEvents,
      hasOrganizers = _ref10$user.hasOrganizers,
      hasTikibar = _ref10$user.hasTikibar,
      isAttendee = _ref10$user.isAttendee,
      isAuthenticated = _ref10$user.isAuthenticated,
      isStaff = _ref10$user.isStaff,
      numOrders = _ref10$user.numOrders,
      numSavedEvents = _ref10$user.numSavedEvents,
      numFollowing = _ref10$user.numFollowing,
      publicId = _ref10$user.publicId,
      thumbnailUrl = _ref10$user.thumbnailUrl,
      fullName = _ref10$user.fullName,
      email = _ref10$user.email,
      showBrowseEvents = _ref10.showBrowseEvents,
      isManageOverviewActive = _ref10.isManageOverviewActive,
      _ref10$iconColor = _ref10.iconColor,
      iconColor = _ref10$iconColor === void 0 ? undefined : _ref10$iconColor,
      _ref10$featureFlags = _ref10.featureFlags,
      featureFlags = _ref10$featureFlags === void 0 ? {} : _ref10$featureFlags;

  if (!isAuthenticated) {
    return null;
  }

  var canUseCredits = featureFlags.launchCreatorCreditsSectionAttendee;
  var accountSettingsPath = 'account-settings';
  return {
    iconColor: iconColor,
    label: firstName,
    fallbackUrl: "".concat(serverUrl, "/").concat(accountSettingsPath, "/"),
    imageUrl: thumbnailUrl,
    navItems: _getUserMenuItems({
      adminServerUrl: adminServerUrl,
      canCreateEvents: canCreateEvents,
      canInvite: canInvite,
      canUseSponsorships: canUseSponsorships,
      canUseStudio: canUseStudio,
      canUseCollections: canUseCollections,
      canUseCredits: canUseCredits,
      hasEvents: hasEvents,
      hasOrganizers: hasOrganizers,
      hasTikibar: hasTikibar,
      isAttendee: isAttendee,
      isStaff: isStaff,
      logoutUrl: logoutUrl,
      numOrders: numOrders,
      numSavedEvents: numSavedEvents,
      numFollowing: numFollowing,
      publicId: publicId,
      requestPath: requestPath,
      serverUrl: serverUrl,
      accountSettingsPath: accountSettingsPath,
      showBrowseEvents: showBrowseEvents,
      fullName: fullName,
      email: email,
      userImageUrl: thumbnailUrl,
      isManageOverviewActive: isManageOverviewActive
    })
  };
};

exports.getUserMenuInfo = getUserMenuInfo;
//# sourceMappingURL=index.js.map